import { Menu, MenuItem, SubMenu } from '@/components/atoms';
import { Space } from 'antd';
import { Link } from 'react-router-dom';
import {
  PATH_SERVICE,
  PATH_SERVICE_MANAGE_ACCOUNT,
  PATH_SERVICE_USAGE,
  PATH_TAX,
  PATH_TAX_CHANGE_HISTORY,
  PATH_TAX_NOTICE_LIST,
} from '@/constants/constant';

import iconPaper from '@images/icon/icon_paper.png';
import iconCar from '@images/icon/icon_car.png';

type TaxMenuProps = {
  path: string;
};

const TaxMenu = ({ path }: TaxMenuProps) => {
  const [root, first] = path.split('/').filterNotNull();
  return (
    <Menu mode="inline" defaultOpenKeys={[`/${first}`]} defaultSelectedKeys={[path]}>
      <SubMenu
        key={PATH_TAX}
        title={
          <Space direction="horizontal">
            <img src={iconPaper} alt="업무관리 아이콘" />
            업무관리
          </Space>
        }
      >
        <MenuItem key={PATH_TAX_NOTICE_LIST}>
          <Link to={PATH_TAX_NOTICE_LIST}>고지서목록</Link>
        </MenuItem>
        <MenuItem key={PATH_TAX_CHANGE_HISTORY}>
          <Link to={PATH_TAX_CHANGE_HISTORY}>민원관리</Link>
        </MenuItem>
      </SubMenu>
      <SubMenu
        key={PATH_SERVICE}
        title={
          <Space direction="horizontal">
            <img src={iconCar} alt="서비스정보 아이콘" />
            서비스 정보
          </Space>
        }
      >
        {/* <MenuItem key={PATH_SERVICE_MANAGE_FORM}> */}
        {/*  <Link to={PATH_SERVICE_MANAGE_FORM}>민원 신청 양식</Link> */}
        {/* </MenuItem> */}
        {/* <MenuItem key={PATH_SERVICE_MANAGE_API}> */}
        {/*  <Link to={PATH_SERVICE_MANAGE_API}>핀카 API 키</Link> */}
        {/* </MenuItem> */}
        <MenuItem key={PATH_SERVICE_MANAGE_ACCOUNT}>
          <Link to={PATH_SERVICE_MANAGE_ACCOUNT}>연동 계정 관리</Link>
        </MenuItem>
        <MenuItem key={PATH_SERVICE_USAGE}>
          <Link to={PATH_SERVICE_USAGE}>사용 내역</Link>
        </MenuItem>
      </SubMenu>
    </Menu>
  );
};

export default TaxMenu;
